<script>
import EntityService from "@/services/entityService.js";
import authService from "@/services/authService";
import CartaoListaDeSolicitacoes from "./ListaDeDados/CartaoListaDeSolicitacoes.vue";
import ModalSolicitacaoDeOrcamento from "./Formulario/ModalSolicitacaoDeOrcamento.vue";
import {
  criarFormularioPadrao,
  formatarNumeroInput,
  gerarPayloadPersistencia,
  normalizaListaSalesOrder,
  parseNumero,
  recalcularCamposPreco,
  STATUS_EM_EXECUCAO_ID,
  STATUS_EM_EXECUCAO_DESC,
  STATUS_PEDIDO_COLOCADO_ID,
  STATUS_PEDIDO_COLOCADO_DESC
} from "./services/solicitacaoDeOrcamentoRules.js";

export default {
  name: "SolicitacaoDeOrcamentoView",
  components: {
    CartaoListaDeSolicitacoes,
    ModalSolicitacaoDeOrcamento
  },
  data() {
    return {
      carregando: false,
      formularioAberto: false,
      modoFormulario: "create",
      orcamentos: [],
      formulario: criarFormularioPadrao(),
      statusOpcoes: [],
      statusDescricaoPorId: {},
      clientes: [],
      contatosCliente: [],
      abrirNovoContato: false,
      novoContato: {
        nome: "",
        email: "",
        telefone: "",
        celular: ""
      },
      vendedores: [],
      tiposDeEquipamento: [],
      propostasTecnicas: [],
      propostasComerciais: [],
      followUps: [],
      revisoes: [],
      orcamentoService: new EntityService("SolicitacaoDeOrcamento"),
      salesOrderLegadoService: new EntityService("SalesOrder"),
      tipoEquipamentoService: new EntityService("TipoDeEquipamento"),
      clienteService: new EntityService("Cliente"),
      contatoService: new EntityService("ClienteContatos"),
      statusService: new EntityService("StatusFollowUp"),
      colaboradorService: new EntityService("Collaborator"),
      followUpService: new EntityService("SalesOrderFollowUp"),
      revisoesService: new EntityService("Revisoes"),
      jobService: new EntityService("Project")
    };
  },
  methods: {
    recalcularCamposPreco() {
      const dadosCalculados = recalcularCamposPreco(this.formulario);
      this.formulario = {
        ...this.formulario,
        ...dadosCalculados
      };
    },

    normalizarCamposNumericosParaInput() {
      this.formulario.valorEstimado = formatarNumeroInput(this.formulario.valorEstimado);
      this.formulario.valorDisponivel = formatarNumeroInput(this.formulario.valorDisponivel);
      this.formulario.ki = formatarNumeroInput(this.formulario.ki, 3);
      this.formulario.porcentagemPIS = formatarNumeroInput(this.formulario.porcentagemPIS);
      this.formulario.porcentagemCOFINS = formatarNumeroInput(this.formulario.porcentagemCOFINS);
      this.formulario.porcentagemIIS = formatarNumeroInput(this.formulario.porcentagemIIS);
      this.formulario.porcentagemICMSVenda = formatarNumeroInput(this.formulario.porcentagemICMSVenda);
      this.formulario.porcentagemIPI = formatarNumeroInput(this.formulario.porcentagemIPI);
      this.formulario.precoVenda_sIPI_cICMS = formatarNumeroInput(this.formulario.precoVenda_sIPI_cICMS);
      this.formulario.precoVenda_sIPI_sICMS = formatarNumeroInput(this.formulario.precoVenda_sIPI_sICMS);
      this.formulario.precoVenda_cISS = formatarNumeroInput(this.formulario.precoVenda_cISS);
      this.formulario.kidoCusto = formatarNumeroInput(this.formulario.kidoCusto);
    },

    getClienteNomePorId(clienteId) {
      const cliente = this.clientes.find((item) => item.id === clienteId);
      return cliente?.nomeFantasia || "";
    },

    getContatoPorId(contatoId) {
      return this.contatosCliente.find((item) => item.id === contatoId) || null;
    },

    getColaboradorNomePorId(colaboradorId) {
      const colaborador = this.vendedores.find((item) => item.id === colaboradorId);
      return colaborador?.nome || "";
    },

    async obterUsuarioLogadoId() {
      try {
        const params = await authService.getUserParams();
        return params?.userId || params?.id || null;
      } catch (_) {
        return null;
      }
    },

    async obterCompanySiteIdAtivo() {
      try {
        const local = window?.localStorage?.getItem("CompanySiteIdSelected");
        if (local) return local;

        const params = await authService.getUserParams();
        return params?.companySiteIdDefault || null;
      } catch (_) {
        return null;
      }
    },

    obterRegistroResponse(response) {
      return response?.data?.data || response?.data || null;
    },

    obterIdRegistro(item = null) {
      if (!item) return null;
      return item.id || item._id || null;
    },

    obterCodigoJob(job = null) {
      if (!job) return "";
      return job.code || job.codigo || job.jobCode || "";
    },

    obterIdJob(job = null) {
      if (!job) return null;
      if (Array.isArray(job)) return this.obterIdJob(job[0]);
      if (typeof job === "object") return this.obterIdRegistro(job) || job.code || null;
      return job;
    },

    aplicarJobNoFormulario(job = null) {
      this.formulario.job = this.obterIdJob(job);
      this.formulario.jobNome = this.obterCodigoJob(job);
    },

    async carregarJobRelacionado(solicitacaoId, dadosBase = {}) {
      const jobInformado =
        dadosBase?.job ||
        dadosBase?.project ||
        dadosBase?.jobId ||
        dadosBase?.projectId ||
        null;

      const jobId = this.obterIdJob(jobInformado);
      if (jobId) {
        try {
          const response = await this.jobService.getById(jobId);
          const job = this.obterRegistroResponse(response) || jobInformado;
          this.aplicarJobNoFormulario(job);
          return job;
        } catch (error) {
          this.aplicarJobNoFormulario(jobInformado);
          return jobInformado;
        }
      }

      if (!solicitacaoId) {
        this.aplicarJobNoFormulario(null);
        return null;
      }

      const camposBusca = [
        "solicitacaoDeOrcamento",
        "solicitacaoDeOrcamentoID",
        "solicitacaoDeOrcamentoId",
        "salesOrder",
        "salesOrderId"
      ];

      for (const campo of camposBusca) {
        try {
          const response = await this.jobService.search(campo, solicitacaoId, 1, 10, null, "Equals");
          const lista = this.extrairListaResponse(response);
          if (Array.isArray(lista) && lista.length > 0) {
            const job = lista[0];
            this.aplicarJobNoFormulario(job);
            return job;
          }
        } catch (error) {
          // tenta o próximo campo
        }
      }

      this.aplicarJobNoFormulario(null);
      return null;
    },

    preencherContatoNoFormulario(contato = null) {
      this.formulario.contato = contato?.id || null;
      this.formulario.contatoNome = contato?.nome || "";
      this.formulario.email = contato?.email || "";
      this.formulario.telefone = contato?.telefone || contato?.celular || "";
      this.formulario.contatoComercialTelefone = contato?.telefone || "";
      this.formulario.contatoComercialCelular = contato?.celular || "";
      this.formulario.contatoComercialEmail = contato?.email || "";
    },

    preencherContatoTecnicoNoFormulario(contato = null) {
      this.formulario.contatoTecnico = contato?.id || null;
      this.formulario.contatoTecnicoNome = contato?.nome || "";
      this.formulario.contatoTecnicoTelefone = contato?.telefone || "";
      this.formulario.contatoTecnicoCelular = contato?.celular || "";
      this.formulario.contatoTecnicoEmail = contato?.email || "";
    },

    async carregarStatus() {
      try {
        const response = await this.statusService.getAll(1, 1000, "", "", null, null, null, "description");
        const lista = response?.data?.data?.data || response?.data?.data || response?.data || [];
        this.statusOpcoes = Array.isArray(lista) ? lista : [];
        this.statusDescricaoPorId = this.statusOpcoes.reduce((acc, status) => {
          if (status?.id) acc[status.id] = status?.description || "Sem status";
          return acc;
        }, {});
      } catch (error) {
        this.statusOpcoes = [];
        this.statusDescricaoPorId = {};
      }
    },

    async carregarClientes() {
      try {
        const response = await this.clienteService.getAll(1, 1000, "", "", null, null, null, "nomeFantasia");
        const lista = response?.data?.data?.data || response?.data?.data || response?.data || [];
        this.clientes = Array.isArray(lista) ? lista : [];
      } catch (error) {
        this.clientes = [];
      }
    },

    async carregarColaboradores() {
      try {
        const response = await this.colaboradorService.getAll(1, 1000, "", "", null, null, null, "name");
        const lista = response?.data?.data?.data || response?.data?.data || response?.data || [];
        this.vendedores = Array.isArray(lista)
          ? lista.map((item) => ({ id: item.id, nome: item.name || item.nome || "" }))
          : [];
      } catch (error) {
        this.vendedores = [];
      }
    },

    async carregarTiposDeEquipamento() {
      try {
        const response = await this.tipoEquipamentoService.getAll(1, 500, "", "", null, null, null, "descricao");
        const lista = response?.data?.data?.data || response?.data?.data || response?.data || [];
        this.tiposDeEquipamento = Array.isArray(lista) ? lista : [];
      } catch (error) {
        this.tiposDeEquipamento = [];
      }
    },

    getTipoEquipamentoById(id) {
      if (!id) return null;
      return this.tiposDeEquipamento.find((t) => t.id === id) || null;
    },

    normalizarTextoComparacao(valor = "") {
      return String(valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();
    },

    resolverStatusId(statusValor = null, statusDescricao = "") {
      const lista = Array.isArray(this.statusOpcoes) ? this.statusOpcoes : [];
      if (!lista.length) return null;

      const statusId = typeof statusValor === "object" ? statusValor?.id : statusValor;
      const statusIdEncontrado = lista.find((item) => item?.id === statusId);
      if (statusIdEncontrado?.id) return statusIdEncontrado.id;

      const descricaoComparacao = this.normalizarTextoComparacao(
        statusDescricao || statusValor?.description || statusValor
      );
      if (!descricaoComparacao) return null;

      const statusPorDescricao = lista.find((item) => {
        const descricaoItem = this.normalizarTextoComparacao(item?.description || item?.descricao || item?.name);
        return descricaoItem === descricaoComparacao;
      });

      return statusPorDescricao?.id || null;
    },

    resolverContatoId(contatoValor = null, contatoNome = "") {
      const lista = Array.isArray(this.contatosCliente) ? this.contatosCliente : [];
      if (!lista.length) return null;

      const contatoId = typeof contatoValor === "object" ? contatoValor?.id : contatoValor;
      const contatoPorId = lista.find((item) => item?.id === contatoId);
      if (contatoPorId?.id) return contatoPorId.id;

      const nomeComparacao = this.normalizarTextoComparacao(
        contatoNome || contatoValor?.nome || contatoValor
      );
      if (!nomeComparacao) return null;

      const contatoPorNome = lista.find((item) => {
        const nomeItem = this.normalizarTextoComparacao(item?.nome || item?.name);
        return nomeItem === nomeComparacao;
      });

      return contatoPorNome?.id || null;
    },

    debugSalvarOrcamento(etapa = "", dados = null) {
      try {
        if (dados !== null && dados !== undefined) {
          console.log(`[SolicitacaoDeOrcamento][salvar] ${etapa}`, dados);
          return;
        }
        console.log(`[SolicitacaoDeOrcamento][salvar] ${etapa}`);
      } catch (_) {
        // noop
      }
    },

    sincronizarContatosDoFormulario() {
      const contatoComercialId = this.resolverContatoId(
        this.formulario.contato,
        this.formulario.contatoNome || this.formulario.contatoComercialNome
      );
      const contatoTecnicoId = this.resolverContatoId(
        this.formulario.contatoTecnico,
        this.formulario.contatoTecnicoNome
      );

      if (contatoComercialId) {
        this.selecionarContato(contatoComercialId);
      } else {
        this.formulario.contato = null;
      }

      if (contatoTecnicoId) {
        this.selecionarContatoTecnico(contatoTecnicoId);
      } else {
        this.formulario.contatoTecnico = null;
      }
    },

    obterSiglaTipoEquipamento(tipo = {}) {
      const siglaBase = tipo?.sigla || tipo?.codigo || tipo?.code || "";
      if (siglaBase) return String(siglaBase).trim().toUpperCase().slice(0, 3);

      const descricaoBase = tipo?.descricao || tipo?.nome || tipo?.description || tipo?.name || "";
      return String(descricaoBase).replace(/\s+/g, "").toUpperCase().slice(0, 3);
    },

    obterSequenciaOrcamento(item = {}) {
      const referencia = item?.code || item?.numeroSolicitacao || item?.numeroProposta || "";
      const numeros = String(referencia).replace(/\D/g, "");
      if (!numeros) return "";
      return numeros.padStart(Math.max(6, numeros.length), "0");
    },

    obterProximaSequenciaPorSigla(sigla = "") {
      const prefixo = String(sigla || "").toUpperCase().slice(0, 3);
      if (!prefixo) return "000001";

      const lista = Array.isArray(this.orcamentos) ? this.orcamentos : [];
      const maior = lista.reduce((acumulado, item) => {
        const codigo = String(item?.numeroProposta || item?.numeroSolicitacao || item?.code || "").toUpperCase();
        if (!codigo.startsWith(`${prefixo}-`)) return acumulado;

        const numero = Number(codigo.replace(/\D/g, ""));
        if (!Number.isFinite(numero)) return acumulado;
        return Math.max(acumulado, numero);
      }, 0);

      return String(maior + 1).padStart(6, "0");
    },

    gerarNumeroProposta(item = {}, siglaOverride = "") {
      const sigla = String(siglaOverride || item?.tipoDeEquipamentoSigla || "").toUpperCase().slice(0, 3);
      let sequencia = this.obterSequenciaOrcamento(item);
      if (!sequencia && !item?.id && sigla) {
        sequencia = this.obterProximaSequenciaPorSigla(sigla);
      }

      if (!sigla && !sequencia) return item?.numeroProposta || "";
      if (!sigla) return sequencia;
      if (!sequencia) return sigla;
      return `${sigla}-${sequencia}`;
    },

    selecionarTipoEquipamento(tipoId) {
      const tipo = this.getTipoEquipamentoById(tipoId);
      const siglaTipo = this.obterSiglaTipoEquipamento(tipo);
      const descricaoTipo = tipo?.descricao || tipo?.nome || tipo?.description || tipo?.name || "";

      this.formulario.tipoDeEquipamento = tipoId || null;
      this.formulario.tipoDeEquipamentoSigla = siglaTipo;
      this.formulario.tipoDeEquipamentoDescricao = descricaoTipo;
      this.formulario._mirror_tipoDeEquipamento = tipo || "";
      this.formulario.numeroProposta = this.gerarNumeroProposta(this.formulario, siglaTipo);
    },

    extrairListaResponse(response) {
      return response?.data?.data?.data || response?.data?.data || response?.data || [];
    },

    obterChaveListaOrcamento(item = {}, origemSchema = "") {
      const id = item?.id || item?._id || item?.code || item?.numeroSolicitacao || "sem-id";
      const schema = origemSchema || item?.origemSchema || "desconhecido";
      return `${schema}:${id}`;
    },

    obterChaveDuplicidadeOrcamento(item = {}) {
      return String(item?.numeroProposta || item?.numeroSolicitacao || item?.code || "").trim();
    },

    ordenarOrcamentosLista(lista = []) {
      const obterNumeroOrdenacao = (item = {}) => {
        const textoBase = String(item?.numeroProposta || item?.numeroSolicitacao || item?.code || "");
        const numeros = textoBase.replace(/\D/g, "");
        return Number(numeros || 0);
      };

      return [...(Array.isArray(lista) ? lista : [])].sort((a, b) => {
        const numeroB = obterNumeroOrdenacao(b);
        const numeroA = obterNumeroOrdenacao(a);
        if (numeroB !== numeroA) return numeroB - numeroA;

        const dataB = new Date(b?.dateGenerate || b?.dataSolicitacao || b?.createdAt || 0).getTime();
        const dataA = new Date(a?.dateGenerate || a?.dataSolicitacao || a?.createdAt || 0).getTime();
        return dataB - dataA;
      });
    },

    atualizarOrcamentoNaLista(item = {}, origemSchema = "SalesOrder") {
      if (!item) return;

      const normalizado = {
        ...normalizaListaSalesOrder({ data: [item] }, this.statusDescricaoPorId)[0],
        origemSchema
      };

      if (!normalizado?.id) return;

      normalizado._listKey = this.obterChaveListaOrcamento(normalizado, origemSchema);

      const listaAtual = Array.isArray(this.orcamentos) ? [...this.orcamentos] : [];
      const indexExistente = listaAtual.findIndex((registro) => registro?._listKey === normalizado._listKey);

      if (indexExistente >= 0) {
        listaAtual.splice(indexExistente, 1, {
          ...listaAtual[indexExistente],
          ...normalizado
        });
      } else {
        listaAtual.unshift(normalizado);
      }

      this.orcamentos = this.ordenarOrcamentosLista(listaAtual);
    },

    async carregarPorIds(service, ids = []) {
      const idsValidos = Array.isArray(ids) ? ids.filter(Boolean) : [];
      if (!idsValidos.length) return [];

      const response = await service.getAll(1, Math.max(idsValidos.length, 50), "", "", idsValidos, null, null, null);
      const lista = this.extrairListaResponse(response);
      return Array.isArray(lista) ? lista : [];
    },

    async buscarRelacionadosPorCampos(service, registroId, campos = []) {
      for (const campo of campos) {
        try {
          const response = await service.search(campo, registroId, 1, 500, null, "Equals");
          const lista = this.extrairListaResponse(response);
          if (Array.isArray(lista) && lista.length > 0) return lista;
        } catch (error) {
          // tenta próximo campo
        }
      }
      return [];
    },

    mapearFollowUp(item = {}) {
      return {
        ...item,
        id: item.id || item._id || null,
        code: item.code || item.codigo || "",
        description: item.description || item.descricao || "",
        data: item.data || item.dataCriacao || "",
        contato_comercial:
          item.contato_comercial ||
          item.contatoComercialNome ||
          item.contatoComercial ||
          "",
        statusDescription:
          item.statusDescription ||
          item.status?.description ||
          this.statusDescricaoPorId[item.status] ||
          ""
      };
    },

    mapearRevisao(item = {}) {
      return {
        ...item,
        revisao: item.revisao || item.code || "",
        dateGenerate: item.dateGenerate || item.dataGeracao || item.data || "",
        statusDescription:
          item.statusDescription ||
          item.status?.description ||
          this.statusDescricaoPorId[item.status] ||
          "",
        _mirror_tipoDeEquipamento: item._mirror_tipoDeEquipamento || ""
      };
    },

    async atualizarVinculoFollowUpsNoSalesOrder(ids = []) {
      const idsUnicos = [...new Set((Array.isArray(ids) ? ids : []).filter(Boolean))];

      const salesOrderResponse = await this.orcamentoService.getById(this.formulario.id);
      const salesOrderAtual =
        salesOrderResponse?.data?.data ||
        salesOrderResponse?.data ||
        { id: this.formulario.id };

      const camposPossiveis = ["followUps", "salesOrderFollowUps", "followUp", "followup"];
      let ultimoErro = null;

      for (const campo of camposPossiveis) {
        try {
          await this.orcamentoService.insertOrUpdate({
            ...salesOrderAtual,
            id: this.formulario.id,
            [campo]: idsUnicos
          });

          this.formulario.followUps = idsUnicos;
          this.formulario.salesOrderFollowUps = idsUnicos;
          return;
        } catch (error) {
          ultimoErro = error;
        }
      }

      if (ultimoErro) throw ultimoErro;
    },

    async carregarContatosDoCliente(clienteId) {
      if (!clienteId) {
        this.contatosCliente = [];
        return;
      }

      try {
        const response = await this.contatoService.search("cliente", clienteId, 1, 1000, null, "Equals");
        const lista = response?.data?.data?.data || response?.data?.data || response?.data || [];
        this.contatosCliente = Array.isArray(lista) ? lista : [];
        this.sincronizarContatosDoFormulario();
      } catch (error) {
        this.contatosCliente = [];
      }
    },

    async selecionarCliente(clienteId) {
      this.formulario.cliente = clienteId || null;
      this.formulario.clienteNome = this.getClienteNomePorId(clienteId);
      this.preencherContatoNoFormulario(null);
      this.preencherContatoTecnicoNoFormulario(null);
      await this.carregarContatosDoCliente(clienteId);
    },

    selecionarContato(contatoId) {
      const contato = this.getContatoPorId(contatoId);
      this.preencherContatoNoFormulario(contato);
    },

    selecionarContatoTecnico(contatoId) {
      const contato = this.getContatoPorId(contatoId);
      this.preencherContatoTecnicoNoFormulario(contato);
    },

    async criarContato(dados = {}) {
      if (!this.formulario.cliente) {
        this.$notfy?.warning("Selecione um cliente para cadastrar contato");
        return;
      }

      if (!this.novoContato.nome) {
        this.$notfy?.warning("Preencha o nome do contato");
        return;
      }

      try {
        this.carregando = true;

        const payload = {
          nome: this.novoContato.nome,
          email: this.novoContato.email,
          telefone: this.novoContato.telefone,
          celular: this.novoContato.celular,
          cliente: this.formulario.cliente
        };

        const response = await this.contatoService.insertOrUpdate(payload);
        const contatoCriado = response?.data?.data || payload;

        await this.carregarContatosDoCliente(this.formulario.cliente);

        const contatoSelecionado =
          this.contatosCliente.find((item) => item.id === contatoCriado?.id) ||
          this.contatosCliente.find((item) => item.nome === contatoCriado?.nome) ||
          contatoCriado;

        if (dados?.tipo === "tecnico") {
          this.preencherContatoTecnicoNoFormulario(contatoSelecionado);
        } else {
          this.preencherContatoNoFormulario(contatoSelecionado);
        }

        this.novoContato = {
          nome: "",
          email: "",
          telefone: "",
          celular: ""
        };
        this.abrirNovoContato = false;

        this.$notfy?.success("Contato criado e vinculado ao cliente");
      } catch (error) {
        this.$notfy?.error("Erro ao criar contato do cliente");
      } finally {
        this.carregando = false;
      }
    },

    async gerarJob() {
      if (!this.formulario?.id) {
        this.$notfy?.warning("Salve a Solicitação de Orçamento antes de gerar o Job");
        return;
      }

      if (this.formulario?.job) {
        this.$notfy?.warning("Já existe um Job vinculado. Redirecionando...");
        this.$router.push("/tela/job");
        return;
      }

      try {
        this.carregando = true;
        const usuarioLogadoId = await this.obterUsuarioLogadoId();

        const vendedorNome =
          this.formulario.vendedorNome ||
          this.getColaboradorNomePorId(this.formulario.vendedor);
        const orcamentistaNome =
          this.formulario.orcamentistaNome ||
          this.getColaboradorNomePorId(this.formulario.orcamentista);
        const valorJob = parseNumero(
          this.formulario.precoVenda_sIPI_cICMS ||
          this.formulario.valorEstimado ||
          this.formulario.valorDisponivel
        );

        // Obter nomes dos contatos
        const contatoComercialObj = this.getContatoPorId(this.formulario.contatoComercial || this.formulario.contato);
        const contatoTecnicoObj = this.getContatoPorId(this.formulario.contatoTecnico);
        const contatoComercialNome = contatoComercialObj?.nome || this.formulario.contatoNome || this.formulario.contatoComercialNome || "";
        const contatoTecnicoNome = contatoTecnicoObj?.nome || this.formulario.contatoTecnicoNome || "";

        const isSalesOrderLegado = this.formulario.origemSchema === "SalesOrder";
        const payloadJob = {
          status: "Iniciado",
          dataAbertura: new Date().toISOString().split("T")[0],
          valorAtual: valorJob,
          valorJob,
          valorInicialJob: valorJob,
          description: `Gerado pela solicitação de orçamento ${this.formulario.numeroProposta || this.formulario.codigo || this.formulario.numeroSolicitacao || ""}`,
          solicitacaoDeOrcamento: isSalesOrderLegado ? undefined : this.formulario.id,
          solicitacaoDeOrcamentoId: isSalesOrderLegado ? undefined : this.formulario.id,
          salesOrder: isSalesOrderLegado ? this.formulario.id : undefined,
          salesOrderId: isSalesOrderLegado ? this.formulario.id : undefined,
          salesOrderCode: isSalesOrderLegado
            ? (this.formulario.numeroProposta || this.formulario.numeroSolicitacao || this.formulario.code || "")
            : undefined,
          solicitacaoDeOrcamentoCodigo: !isSalesOrderLegado
            ? (this.formulario.numeroProposta || this.formulario.numeroSolicitacao || this.formulario.code || "")
            : undefined,
          numeroProposta: this.formulario.numeroProposta || this.formulario.numeroSolicitacao || this.formulario.code || "",
          cliente: this.formulario.cliente || null,
          clienteNome: this.formulario.clienteNome || this.getClienteNomePorId(this.formulario.cliente),
          comercial: this.formulario.orcamentista || this.formulario.vendedor || null,
          vendedorNome,
          orcamentistaNome,
          tipo: this.formulario._mirror_tipoDeEquipamento || null,
          contatoComercial: this.formulario.contatoComercial || this.formulario.contato || null,
          contatoComercialNome,
          contatoTecnico: this.formulario.contatoTecnico || null,
          contatoTecnicoNome,
          revisaoSolicitacaoOrcamento: this.formulario.version || this.formulario.codigo || "",
          pedidoCompra: this.formulario.referenciaCliente || this.formulario.cliente_referencia || "",
          email: this.formulario.contatoComercialEmail || this.formulario.email || "",
          owner: usuarioLogadoId || undefined,
          ownerId: usuarioLogadoId || undefined,
          owners: usuarioLogadoId ? [usuarioLogadoId] : undefined
        };

        if (!payloadJob.owner) delete payloadJob.owner;
        if (!payloadJob.ownerId) delete payloadJob.ownerId;
        if (!payloadJob.owners) delete payloadJob.owners;
        if (!payloadJob.solicitacaoDeOrcamento) delete payloadJob.solicitacaoDeOrcamento;
        if (!payloadJob.solicitacaoDeOrcamentoId) delete payloadJob.solicitacaoDeOrcamentoId;
        if (!payloadJob.salesOrder) delete payloadJob.salesOrder;
        if (!payloadJob.salesOrderId) delete payloadJob.salesOrderId;
        if (!payloadJob.salesOrderCode) delete payloadJob.salesOrderCode;
        if (!payloadJob.solicitacaoDeOrcamentoCodigo) delete payloadJob.solicitacaoDeOrcamentoCodigo;
        if (!payloadJob.tipo) delete payloadJob.tipo;
        if (!payloadJob.contatoComercial) delete payloadJob.contatoComercial;
        if (!payloadJob.contatoTecnico) delete payloadJob.contatoTecnico;

        const response = await this.jobService.insertOrUpdate(payloadJob);
        const jobCriado = this.obterRegistroResponse(response) || payloadJob;

        this.formulario.vendedorNome = vendedorNome;
        this.formulario.orcamentistaNome = orcamentistaNome;
        this.aplicarJobNoFormulario(jobCriado);

        const servicePersistencia = this.formulario.origemSchema === "SalesOrder"
          ? this.salesOrderLegadoService
          : this.orcamentoService;
        const payloadOrcamento = {
          ...gerarPayloadPersistencia(this.formulario),
          id: this.formulario.id,
          numeroProposta: this.gerarNumeroProposta(this.formulario),
          job: this.formulario.job,
          jobNome: this.formulario.jobNome,
          status: STATUS_PEDIDO_COLOCADO_ID,
          statusDescription: STATUS_PEDIDO_COLOCADO_DESC,
          dateGenerate: new Date().toISOString().split("T")[0],
          tipoDeEquipamento: this.formulario.tipoDeEquipamento || null,
          tipoDeEquipamentoSigla: this.formulario.tipoDeEquipamentoSigla || "",
          tipoDeEquipamentoDescricao: this.formulario.tipoDeEquipamentoDescricao || "",
          contatoComercialNome: this.formulario.contatoNome || this.formulario.contatoComercialNome || "",
          contatoTecnicoNome: this.formulario.contatoTecnicoNome || ""
        };
        await servicePersistencia.insertOrUpdate(payloadOrcamento);
        this.formulario.status = STATUS_PEDIDO_COLOCADO_ID;
        this.formulario.statusDescription = STATUS_PEDIDO_COLOCADO_DESC;
        this.atualizarOrcamentoNaLista(payloadOrcamento, this.formulario.origemSchema || "SolicitacaoDeOrcamento");

        this.$notfy?.success("Job gerado com sucesso");
        this.$router.push("/tela/job");
      } catch (error) {
        const mensagem =
          error?.response?.data?.message ||
          "Não foi possível gerar o Job desta Solicitação de Orçamento";
        this.$notfy?.error(mensagem);
        console.error(error);
      } finally {
        this.carregando = false;
      }
    },

    novaPropostaTecnica() {
      this.$notfy?.warning("Abertura de Proposta Técnica em desenvolvimento");
    },

    novaPropostaComercial() {
      this.$notfy?.warning("Abertura de Proposta Comercial em desenvolvimento");
    },

    async novoFollowUp(formData = {}) {
      if (!this.formulario?.id) {
        this.$notfy?.warning("Salve a Solicitação de Orçamento antes de criar Follow-Up");
        return;
      }

      try {
        this.carregando = true;

        const payloadBase = {
          description: formData.description || "",
          data: formData.data || new Date().toISOString().split("T")[0],
          contato_comercial: formData.contato_comercial || this.formulario.contatoNome || "",
          salesOrder: this.formulario.id,
          solicitacaoOrcamento: this.formulario.id,
          solicitacaoOrcamentoId: this.formulario.id
        };
        if (formData.status) payloadBase.status = formData.status;

        const response = await this.followUpService.insertOrUpdate(payloadBase);
        const followUpCriadoId = response?.data?.data?.id || response?.data?.id || null;

        if (followUpCriadoId) {
          const followUpsAtuais = Array.isArray(this.formulario.followUps)
            ? this.formulario.followUps
            : (Array.isArray(this.formulario.salesOrderFollowUps) ? this.formulario.salesOrderFollowUps : []);
          const followUpsAtualizados = [...new Set([...followUpsAtuais, followUpCriadoId])];
          try { await this.atualizarVinculoFollowUpsNoSalesOrder(followUpsAtualizados); } catch (_) { /* vínculo via campo salesOrder no FU */ }
        }

        this.$notfy?.success("Follow-Up incluído com sucesso");
        await this.carregarSubEntidades(this.formulario.id);
      } catch (error) {
        const mensagem = error?.response?.data?.message || "Não foi possível incluir o Follow-Up";
        this.$notfy?.error(mensagem);
        console.error(error);
      } finally {
        this.carregando = false;
      }
    },

    async editarFollowUp(item = {}) {
      const id = item?.id || item?._id;
      if (!id) return;

      try {
        this.carregando = true;
        const payload = {
          ...item,
          id,
          salesOrder: item.salesOrder || this.formulario.id,
          solicitacaoOrcamento: item.solicitacaoOrcamento || this.formulario.id,
          solicitacaoOrcamentoId: item.solicitacaoOrcamentoId || this.formulario.id
        };
        if (!payload.status) delete payload.status;
        await this.followUpService.insertOrUpdate(payload);
        this.$notfy?.success("Follow-Up atualizado com sucesso");
        await this.carregarSubEntidades(this.formulario.id);
      } catch (error) {
        const mensagem = error?.response?.data?.message || "Erro ao atualizar Follow-Up";
        this.$notfy?.error(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    async deletarFollowUp(item = {}) {
      const id = item?.id || item?._id;
      if (!id) return;

      const confirmar = window.confirm("Tem certeza que deseja excluir este Follow-Up?");
      if (!confirmar) return;

      try {
        this.carregando = true;
        await this.followUpService.delete(id);

        const followUpsAtuais = Array.isArray(this.formulario.followUps)
          ? this.formulario.followUps
          : (Array.isArray(this.formulario.salesOrderFollowUps) ? this.formulario.salesOrderFollowUps : []);

        const followUpsAtualizados = followUpsAtuais.filter((followUpId) => followUpId !== id);
        await this.atualizarVinculoFollowUpsNoSalesOrder(followUpsAtualizados);

        this.$notfy?.success("Follow-Up removido com sucesso");
        await this.carregarSubEntidades(this.formulario.id);
      } catch (error) {
        const mensagem = error?.response?.data?.message || "Erro ao excluir Follow-Up";
        this.$notfy?.error(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    async carregarSubEntidades(salesOrderId) {
      this.propostasTecnicas = [];
      this.propostasComerciais = [];
      this.followUps = [];
      this.revisoes = [];

      if (!salesOrderId) return;

      try {
        const idsFollowUps =
          this.formulario?.followUps ||
          this.formulario?.salesOrderFollowUps ||
          this.formulario?.followUp ||
          this.formulario?.followup ||
          [];

        let followUpsLista = await this.carregarPorIds(this.followUpService, idsFollowUps);
        if (!followUpsLista.length) {
          followUpsLista = await this.buscarRelacionadosPorCampos(this.followUpService, salesOrderId, [
            "salesOrder",
            "salesOrderId",
            "solicitacaoOrcamento",
            "solicitacaoOrcamentoId"
          ]);
        }
        this.followUps = (Array.isArray(followUpsLista) ? followUpsLista : []).map((item) => this.mapearFollowUp(item));
      } catch (error) {
        this.followUps = [];
      }

      try {
        const idsRevisoes =
          this.formulario?.revisoesComerciais ||
          this.formulario?.revisoes ||
          [];

        let revisoesLista = await this.carregarPorIds(this.revisoesService, idsRevisoes);
        if (!revisoesLista.length) {
          revisoesLista = await this.buscarRelacionadosPorCampos(this.revisoesService, salesOrderId, [
            "salesOrder",
            "salesOrderId",
            "solicitacaoOrcamento",
            "solicitacaoOrcamentoId"
          ]);
        }
        this.revisoes = (Array.isArray(revisoesLista) ? revisoesLista : []).map((item) => this.mapearRevisao(item));
      } catch (error) {
        this.revisoes = [];
      }
    },

    limparFormulario() {
      this.formulario = criarFormularioPadrao();
      this.formulario.origemSchema = "SalesOrder";
      this.propostasTecnicas = [];
      this.propostasComerciais = [];
      this.followUps = [];
      this.revisoes = [];
    },

    abrirFormulario() {
      this.modoFormulario = "create";
      this.limparFormulario();
      this.recalcularCamposPreco();
      this.normalizarCamposNumericosParaInput();
      this.formularioAberto = true;
    },

    fecharFormulario() {
      this.formularioAberto = false;
      this.modoFormulario = "create";
      this.limparFormulario();
    },

    adicionarItem() {
      this.formulario.itens.push({
        descricao: "",
        quantidade: 1,
        unidade: "",
        observacao: ""
      });
    },

    removerItem(index) {
      this.formulario.itens.splice(index, 1);
    },

    async carregarOrcamentos() {
      try {
        this.carregando = true;
        const [responseNovo, responseLegado] = await Promise.allSettled([
          this.orcamentoService.getAll(1, 500, "", "", null, null, null, "code"),
          this.salesOrderLegadoService.getAll(1, 500, "", "", null, null, null, "code")
        ]);
        const novos = responseNovo.status === "fulfilled"
          ? normalizaListaSalesOrder(responseNovo.value, this.statusDescricaoPorId)
            .map((item) => ({
              ...item,
              origemSchema: "SolicitacaoDeOrcamento",
              _listKey: this.obterChaveListaOrcamento(item, "SolicitacaoDeOrcamento")
            }))
          : [];
        const legados = responseLegado.status === "fulfilled"
          ? normalizaListaSalesOrder(responseLegado.value, this.statusDescricaoPorId)
            .map((item) => ({
              ...item,
              origemSchema: "SalesOrder",
              _listKey: this.obterChaveListaOrcamento(item, "SalesOrder")
            }))
          : [];

        const mapa = new Map();
        [...novos, ...legados].forEach((registro) => {
          const chaveDuplicidade = this.obterChaveDuplicidadeOrcamento(registro);
          const chaveLista = registro._listKey || this.obterChaveListaOrcamento(registro, registro.origemSchema);
          const chave = chaveDuplicidade || chaveLista;

          if (!mapa.has(chave)) {
            mapa.set(chave, registro);
            return;
          }

          const existente = mapa.get(chave);
          if (existente?.origemSchema !== "SolicitacaoDeOrcamento" && registro?.origemSchema === "SolicitacaoDeOrcamento") {
            mapa.set(chave, registro);
          }
        });

        this.orcamentos = this.ordenarOrcamentosLista(Array.from(mapa.values()));
      } catch (error) {
        this.$notfy?.error("Erro ao carregar solicitações de orçamento");
        console.error(error);
      } finally {
        this.carregando = false;
      }
    },

    async abrirOrcamentoPorModo(orcamento = {}, modo = "edit") {
      let base = { ...orcamento };
      const id = orcamento?.id;
      const origemSchema = orcamento?.origemSchema || "SolicitacaoDeOrcamento";
      const serviceDetalhe = origemSchema === "SalesOrder"
        ? this.salesOrderLegadoService
        : this.orcamentoService;

      if (id) {
        try {
          const response = await serviceDetalhe.getById(id);
          const detalhe = response?.data?.data || response?.data || {};
          base = { ...base, ...detalhe, origemSchema };
        } catch (error) {
          // fallback para os dados da lista
        }
      }

      this.modoFormulario = modo;
      this.formulario = {
        ...criarFormularioPadrao(),
        ...base,
        origemSchema,
        numeroProposta: base?.numeroProposta || base?.numeroSolicitacao || base?.code || "",
        itens: Array.isArray(base.itens) ? [...base.itens] : []
      };

      this.formulario.clienteNome = base?.clienteNome || this.getClienteNomePorId(this.formulario.cliente);
      this.formulario.vendedorNome =
        base?.vendedorNome || this.getColaboradorNomePorId(this.formulario.vendedor);
      this.formulario.orcamentistaNome =
        base?.orcamentistaNome || this.getColaboradorNomePorId(this.formulario.orcamentista);

      // tipo de equipamento
      const tipoRaw = base?.tipoDeEquipamento;
      const tipoId = tipoRaw && typeof tipoRaw === "object" ? tipoRaw.id : tipoRaw;
      const tipoObj = this.getTipoEquipamentoById(tipoId) || (typeof tipoRaw === "object" ? tipoRaw : null);
      this.formulario.tipoDeEquipamento = tipoId || null;
      this.formulario.tipoDeEquipamentoSigla =
        base?.tipoDeEquipamentoSigla ||
        this.obterSiglaTipoEquipamento(tipoObj || {});
      this.formulario.tipoDeEquipamentoDescricao =
        base?.tipoDeEquipamentoDescricao ||
        tipoObj?.descricao ||
        tipoObj?.nome ||
        tipoObj?.description ||
        tipoObj?.name ||
        "";
      this.formulario._mirror_tipoDeEquipamento = tipoObj || base?._mirror_tipoDeEquipamento || "";
      this.formulario.numeroProposta = this.gerarNumeroProposta(this.formulario);

      this.carregarContatosDoCliente(this.formulario.cliente).then(() => {
        this.sincronizarContatosDoFormulario();
      });

      await this.carregarJobRelacionado(this.formulario.id, base);

      this.recalcularCamposPreco();
      this.normalizarCamposNumericosParaInput();
      this.carregarSubEntidades(this.formulario.id);
      this.formularioAberto = true;
    },

    async editarOrcamento(orcamento = {}) {
      await this.abrirOrcamentoPorModo(orcamento, "edit");
    },

    async visualizarOrcamento(orcamento = {}) {
      await this.abrirOrcamentoPorModo(orcamento, "view");
    },

    async salvarOrcamento() {
      try {
        this.carregando = true;

        this.debugSalvarOrcamento("formulario-inicial", {
          id: this.formulario.id,
          code: this.formulario.code,
          numeroProposta: this.formulario.numeroProposta,
          cliente: this.formulario.cliente,
          clienteNome: this.formulario.clienteNome,
          status: this.formulario.status,
          statusDescription: this.formulario.statusDescription,
          contato: this.formulario.contato,
          contatoNome: this.formulario.contatoNome,
          contatoTecnico: this.formulario.contatoTecnico,
          contatoTecnicoNome: this.formulario.contatoTecnicoNome,
          descricao: this.formulario.descricao,
          tipoDeEquipamento: this.formulario.tipoDeEquipamento,
          tipoDeEquipamentoSigla: this.formulario.tipoDeEquipamentoSigla
        });

        if (!this.formulario.cliente) {
          this.$notfy?.warning("Preencha o campo \"Cliente\" para continuar");
          this.debugSalvarOrcamento("validacao-sem-cliente");
          return;
        }
        if (!this.formulario.descricao) {
          this.$notfy?.warning("Preencha o campo \"Descrição do Projeto / Equipamento\" para continuar (campo laranja logo abaixo dos dados gerais)");
          this.debugSalvarOrcamento("validacao-sem-descricao");
          return;
        }

        const statusIdResolvido = this.resolverStatusId(
          this.formulario.status,
          this.formulario.statusDescription
        ) || this.formulario.status || STATUS_EM_EXECUCAO_ID;
        const contatoComercialIdResolvido = this.resolverContatoId(
          this.formulario.contato,
          this.formulario.contatoNome || this.formulario.contatoComercialNome
        );
        const contatoTecnicoIdResolvido = this.resolverContatoId(
          this.formulario.contatoTecnico,
          this.formulario.contatoTecnicoNome
        );
        const servicePersistencia = this.formulario.origemSchema === "SalesOrder"
          ? this.salesOrderLegadoService
          : this.orcamentoService;
        const schemaPersistencia = this.formulario.origemSchema === "SalesOrder"
          ? "SalesOrder"
          : "SolicitacaoDeOrcamento";

        this.debugSalvarOrcamento("relacoes-resolvidas", {
          origemSchema: this.formulario.origemSchema,
          schemaPersistencia,
          statusOriginal: this.formulario.status,
          statusDescription: this.formulario.statusDescription,
          statusIdResolvido,
          contatoOriginal: this.formulario.contato,
          contatoNome: this.formulario.contatoNome || this.formulario.contatoComercialNome,
          contatoComercialIdResolvido,
          contatoTecnicoOriginal: this.formulario.contatoTecnico,
          contatoTecnicoNome: this.formulario.contatoTecnicoNome,
          contatoTecnicoIdResolvido,
          statusOpcoes: (this.statusOpcoes || []).map((item) => ({ id: item.id, description: item.description })),
          contatosCliente: (this.contatosCliente || []).map((item) => ({ id: item.id, nome: item.nome }))
        });

        const payload = gerarPayloadPersistencia(this.formulario);
        const isSalesOrderLegado = schemaPersistencia === "SalesOrder";
        const usuarioLogadoId = await this.obterUsuarioLogadoId();
        const companySiteIdAtivo = await this.obterCompanySiteIdAtivo();
        const tipoSelecionado =
          this.getTipoEquipamentoById(this.formulario.tipoDeEquipamento) ||
          (typeof this.formulario._mirror_tipoDeEquipamento === "object"
            ? this.formulario._mirror_tipoDeEquipamento
            : null);
        const tipoDescricaoCompleta =
          tipoSelecionado?.descricao ||
          tipoSelecionado?.nome ||
          tipoSelecionado?.description ||
          tipoSelecionado?.name ||
          this.formulario.tipoDeEquipamentoDescricao ||
          "";
        payload.numeroProposta = this.gerarNumeroProposta(this.formulario);
        payload.codigo = payload.codigo || payload.code || payload.numeroProposta || "";
        payload.code = payload.code || payload.codigo || payload.numeroProposta || "";
        payload.numeroSolicitacao = payload.numeroSolicitacao || payload.code || this.formulario.numeroSolicitacao || "";

        if (!payload.id) {
          const numeroGerado = payload.numeroProposta || this.gerarNumeroProposta(payload);
          payload.numeroProposta = numeroGerado;
          payload.codigo = numeroGerado;
          payload.code = numeroGerado;
          payload.numeroSolicitacao = numeroGerado;
        }

        payload.companySiteId =
          payload.companySiteId ||
          this.formulario.companySiteId ||
          companySiteIdAtivo ||
          undefined;
        payload.status = statusIdResolvido;
        payload.statusDescription =
          this.statusDescricaoPorId[statusIdResolvido] ||
          this.formulario.statusDescription ||
          STATUS_EM_EXECUCAO_DESC;
        payload.clienteNome = this.formulario.clienteNome || this.getClienteNomePorId(payload.cliente);
        payload.vendedorNome = this.formulario.vendedorNome || this.getColaboradorNomePorId(this.formulario.vendedor);
        payload.orcamentistaNome = this.formulario.orcamentistaNome || this.getColaboradorNomePorId(this.formulario.orcamentista);
        const contatoComercialObj = this.getContatoPorId(contatoComercialIdResolvido);
        const contatoTecnicoObj = this.getContatoPorId(contatoTecnicoIdResolvido);
        payload.contato = contatoComercialIdResolvido || undefined;
        payload.contatoComercial = contatoComercialIdResolvido || undefined;
        payload.contatoComercialNome =
          contatoComercialObj?.nome ||
          this.formulario.contatoNome ||
          this.formulario.contatoComercialNome ||
          "";
        payload.contatoComercialEmail = this.formulario.email || this.formulario.contatoComercialEmail || "";
        payload.contatoComercialTelefone = this.formulario.telefone || this.formulario.contatoComercialTelefone || "";
        payload.contatoTecnico = contatoTecnicoIdResolvido || undefined;
        payload.contatoTecnicoNome = contatoTecnicoObj?.nome || this.formulario.contatoTecnicoNome || "";
        payload.contatoTecnicoTelefone = contatoTecnicoObj?.telefone || this.formulario.contatoTecnicoTelefone || "";
        payload.contatoTecnicoCelular = contatoTecnicoObj?.celular || this.formulario.contatoTecnicoCelular || "";
        payload.contatoTecnicoEmail = contatoTecnicoObj?.email || this.formulario.contatoTecnicoEmail || "";
        payload.tipoDeEquipamento = this.formulario.tipoDeEquipamento || null;
        payload.tipoDeEquipamentoSigla = this.formulario.tipoDeEquipamentoSigla || "";
        payload.tipoDeEquipamentoDescricao = this.formulario.tipoDeEquipamentoDescricao || "";
        payload._mirror_tipoDeEquipamento =
          this.formulario.tipoDeEquipamento ||
          tipoSelecionado?.id ||
          this.formulario._mirror_tipoDeEquipamento ||
          "";

        if (isSalesOrderLegado) {
          payload._mirror_tipo = tipoDescricaoCompleta || this.formulario.tipoDeEquipamentoSigla || "";
          payload._mirror_valor_sIPI_cICMS = parseNumero(
            payload.precoVenda_sIPI_cICMS || payload.valorDisponivel || 0
          );
          payload.owners =
            Array.isArray(payload.owners) && payload.owners.length
              ? payload.owners
              : (usuarioLogadoId ? [usuarioLogadoId] : undefined);

          const dataGeracao = (payload.dateGenerate || new Date().toISOString().split("T")[0]).split("T")[0];
          payload.dateGenerate = `${dataGeracao}T03:00:00Z`;

          payload.statusDescription = String(payload.statusDescription || STATUS_EM_EXECUCAO_DESC).toUpperCase();
          payload.liberar = Boolean(payload.liberar);

          const camposPermitidosSalesOrder = new Set([
            "id",
            "liberar",
            "codigo",
            "companySiteId",
            "status",
            "statusDescription",
            "job",
            "ultimaRevisao",
            "version",
            "tipoDeOrcamento",
            "_mirror_tipo",
            "dateGenerate",
            "_mirror_tipoDeEquipamento",
            "_mirror_valor_sIPI_cICMS",
            "cliente",
            "clienteNome",
            "cliente_referencia",
            "vendedor",
            "vendedorNome",
            "orcamentista",
            "orcamentistaNome",
            "contatoComercial",
            "contatoComercialNome",
            "contatoComercialTelefone",
            "contatoComercialCelular",
            "contatoComercialEmail",
            "contatoTecnico",
            "contatoTecnicoNome",
            "contatoTecnicoTelefone",
            "contatoTecnicoCelular",
            "contatoTecnicoEmail",
            "owners",
            "revisoesTecnicas",
            "revisoesComerciais",
            "followUp",
            "revisoes"
          ]);

          Object.keys(payload).forEach((chave) => {
            if (!camposPermitidosSalesOrder.has(chave) || payload[chave] === undefined) {
              delete payload[chave];
            }
          });
        }

        if (!payload.contato) delete payload.contato;
        if (!payload.contatoComercial) delete payload.contatoComercial;
        if (!payload.contatoTecnico) delete payload.contatoTecnico;
        if (!payload.companySiteId) delete payload.companySiteId;
        if (!payload.owners) delete payload.owners;

        let payloadParaSalvar = payload;
        let payloadComplementarPosCreate = null;

        if (isSalesOrderLegado && !payload.id) {
          payloadParaSalvar = {
            liberar: Boolean(payload.liberar),
            codigo: payload.codigo || payload.code || payload.numeroProposta || "",
            companySiteId: payload.companySiteId,
            status: payload.status || STATUS_EM_EXECUCAO_ID,
            statusDescription: String(payload.statusDescription || STATUS_EM_EXECUCAO_DESC).toUpperCase(),
            dateGenerate: payload.dateGenerate,
            _mirror_tipo: payload._mirror_tipo || tipoDescricaoCompleta || this.formulario.tipoDeEquipamentoSigla || "",
            _mirror_tipoDeEquipamento: payload._mirror_tipoDeEquipamento,
            cliente: payload.cliente,
            vendedor: payload.vendedor,
            orcamentista: payload.orcamentista,
            owners: payload.owners
          };

          if (payload.contatoComercial) payloadParaSalvar.contatoComercial = payload.contatoComercial;
          if (payload.contatoTecnico) payloadParaSalvar.contatoTecnico = payload.contatoTecnico;
          if (payload.cliente_referencia) payloadParaSalvar.cliente_referencia = payload.cliente_referencia;

          payloadComplementarPosCreate = { ...payload };
          delete payloadComplementarPosCreate.id;
        }

        this.debugSalvarOrcamento("payload-final", payloadParaSalvar);

        const response = await servicePersistencia.insertOrUpdate(payloadParaSalvar);
        const retornoComErroLegado =
          isSalesOrderLegado && (
            Number(response?.data?.status || 0) >= 400 ||
            response?.success === false
          );

        let registroSalvo = this.obterRegistroResponse(response) || payloadParaSalvar;

        if (retornoComErroLegado) {
          this.debugSalvarOrcamento("retorno-legacy-action-com-erro", response?.data);
          const codigoBusca = payload.codigo || payload.code || payload.numeroProposta;
          if (codigoBusca) {
            try {
              const responseBusca = await servicePersistencia.search("codigo", codigoBusca, 1, 1, null, "Equals");
              const listaBusca = this.extrairListaResponse(responseBusca);
              if (Array.isArray(listaBusca) && listaBusca.length > 0) {
                registroSalvo = listaBusca[0];
              }
            } catch (_) {
              // fallback para payload local
            }
          }
        }
        const registroSalvoId = this.obterIdRegistro(registroSalvo) || payload.id || null;

        if (payloadComplementarPosCreate && registroSalvoId) {
          try {
            await servicePersistencia.insertOrUpdate({
              ...payloadComplementarPosCreate,
              id: registroSalvoId
            });
          } catch (erroComplementar) {
            this.debugSalvarOrcamento("aviso-update-complementar", {
              id: registroSalvoId,
              message: erroComplementar?.message,
              data: erroComplementar?.response?.data || erroComplementar?.data
            });
          }
        }

        if (registroSalvoId) {
          try {
            const responseDetalhe = await servicePersistencia.getById(registroSalvoId);
            registroSalvo = this.obterRegistroResponse(responseDetalhe) || registroSalvo;
          } catch (errorDetalhe) {
            this.debugSalvarOrcamento("aviso-sem-detalhe-pos-save", {
              registroSalvoId,
              message: errorDetalhe?.message
            });
          }
        }

        this.$notfy?.success("Solicitação salva com sucesso");
        this.fecharFormulario();
        await this.carregarOrcamentos();
        this.atualizarOrcamentoNaLista(registroSalvo, schemaPersistencia);
      } catch (error) {
        this.debugSalvarOrcamento("erro-save", {
          message: error?.message,
          responseStatus: error?.response?.status,
          responseData: error?.response?.data,
          responseErrors: error?.response?.data?.data,
          stack: error?.stack
        });
        this.$notfy?.error("Erro ao salvar solicitação de orçamento");
        console.error(error);
      } finally {
        this.carregando = false;
      }
    },

    async deletarOrcamento(orcamento = {}) {
      const id = orcamento?.id;
      if (!id) {
        this.$notfy?.warning("Não foi possível identificar o registro para exclusão");
        return;
      }

      const confirmar = window.confirm("Tem certeza que deseja deletar esta solicitação?");
      if (!confirmar) return;

      try {
        this.carregando = true;
        await this.orcamentoService.delete(id);
        this.$notfy?.success("Solicitação removida com sucesso");
        await this.carregarOrcamentos();
      } catch (error) {
        this.$notfy?.error("Erro ao deletar solicitação de orçamento");
        console.error(error);
      } finally {
        this.carregando = false;
      }
    }
  },
  watch: {
    "formulario.valorDisponivel"() {
      this.recalcularCamposPreco();
    },
    "formulario.ki"() {
      this.recalcularCamposPreco();
    },
    "formulario.porcentagemICMSVenda"() {
      this.recalcularCamposPreco();
    },
    "formulario.precoVenda_sIPI_cICMS"() {
      this.recalcularCamposPreco();
    }
  },
  async mounted() {
    await Promise.all([
      this.carregarStatus(),
      this.carregarClientes(),
      this.carregarColaboradores(),
      this.carregarTiposDeEquipamento()
    ]);
    await this.carregarOrcamentos();
  }
};
</script>

<template>
  <main class="c-main">
    <CartaoListaDeSolicitacoes
      :carregando="carregando"
      :orcamentos="orcamentos"
      :usuario-nome="''"
      @novo="abrirFormulario"
      @recarregar="carregarOrcamentos"
      @visualizar="visualizarOrcamento"
      @editar="editarOrcamento"
      @deletar="deletarOrcamento"
    />

    <ModalSolicitacaoDeOrcamento
      :formulario-aberto="formularioAberto"
      :formulario="formulario"
      :status-opcoes="statusOpcoes"
      :clientes="clientes"
      :contatos-cliente="contatosCliente"
      :vendedores="vendedores"
      :tipos-de-equipamento="tiposDeEquipamento"
      :abrir-novo-contato="abrirNovoContato"
      :novo-contato="novoContato"
      :follow-ups="followUps"
      :revisoes="revisoes"
      :carregando="carregando"
      :somente-leitura="modoFormulario === 'view'"
      @update:formularioAberto="formularioAberto = $event"
      @update:abrirNovoContato="abrirNovoContato = $event"
      @fechar="fecharFormulario"
      @salvar="salvarOrcamento"
      @selecionar-cliente="selecionarCliente"
      @selecionar-contato="selecionarContato"
      @selecionar-contato-tecnico="selecionarContatoTecnico"
      @selecionar-tipo-equipamento="selecionarTipoEquipamento"
      @criar-contato="criarContato"
      @novo-followup="novoFollowUp"
      @editar-followup="editarFollowUp"
      @deletar-followup="deletarFollowUp"
      @gerar-job="gerarJob"
    />
  </main>
</template>

<style scoped>
.c-main {
  display: grid;
  gap: 15px;
}
</style>
